import { errors as _errors } from 'lib_ui-primitives';
import { constants, globalConfig } from 'lib_ui-services';

const _p = {
    globalConfig,
    now: Date.now
};
export const _private = _p;

export default {
    verb: 'doingValidate',
    namespace: 'item',
    relation: 'transaction',
    description: 'Beep on scan accept/reject for RB DirectScan.',
    priority: 5,
    useCaseIds: [constants.useCaseIds.RB_DIRECTSCAN],
    prerequisites: [
        {
            context: {
                verb: 'get',
                namespace: 'item',
                relation: 'transaction',
                type: 'find'
            },
            query: ({ data }) => {
                const duplicateWindowHours = Number(_p.globalConfig()?.tenantSettings?.duplicateWindow);
                if (!duplicateWindowHours || Number.isNaN(duplicateWindowHours)) {
                    // Window not configured — return a query that matches nothing so the
                    // prerequisite finds no duplicates and the scan is accepted silently.
                    // NOTE: throwing here propagates as a user-visible form error for this
                    // context type, unlike other prerequisite structures.
                    return { _id: { $in: [] } };
                }
                const { customField1, customField2, customField3, customField4, customField5 } = data?.newRecord ?? {};
                const duplicateWindow = new Date(_p.now() - duplicateWindowHours * 60 * 60 * 1000);
                return {
                    customField1,
                    customField2,
                    customField3,
                    customField4,
                    customField5,
                    'meta.createdTime': { $gte: duplicateWindow.toISOString() }
                };
            }
        }
    ],
    logic: doingValidate
};

async function doingValidate(message) {
    const [localResult = {}] = message.prerequisiteResults || [];

    if (localResult.result?.length) {
        message.dispatch?.(
            {
                isError: true,
                message: 'Scan Rejected',
                type: constants.notificationTypes.SOUND,
                duration: 500,
                volume: 1
            },
            { verb: 'pop', namespace: 'application', relation: 'notification' }
        );
        throw new _errors.ValidationError('You already scanned this item today.', {});
    }

    message.dispatch?.(
        {
            isError: false,
            message: 'Scan Accepted',
            type: constants.notificationTypes.SOUND,
            duration: 500,
            volume: 1
        },
        { verb: 'pop', namespace: 'application', relation: 'notification' }
    );
    return message;
}
